<app-dialog
  [title]="data?.isPriceSettings ? 'Update Bulk Settings' : 'Update Bulk'"
  [description]="'Supported file types: .csv & .xlsx'"
  [actions]="actions"
  (action)="emitAction($event)"
  (close)="close()"
>
  <div class="upload" *ngIf="!tableData">
    <label for="file-upload">
      <app-drag-indicator
        (click)="clickToUpload()"
        [actionType]="'Click or drag to upload your file'"
        [isHovered]="isHovered"
      ></app-drag-indicator>
      <input
        #fileInput
        (click)="fileInput.value = null"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        (change)="handleFileInput($event.target.files)"
        id="file-upload"
      />
    </label>
  </div>
  <app-bulk-import-review
    [data]="uploadData"
    (actionChanged)="actionChanged($event)"
    (close)="close()"
    *ngIf="tableData && validExtention"
  ></app-bulk-import-review>
</app-dialog>
